import { BaseApi } from 'Core/api/BaseApi'

export class Api extends BaseApi {
  getUsers = async fields => {
    const defaultResponse = {users: [], totalCount: 0, error: null}
    try {
      const { body } = await Api.post('/user/list', fields)
      if (!body.error && Array.isArray(body)) {
        return { users: body }
      } else {
        defaultResponse.error = body.error
        return defaultResponse
      }
    } catch (e) {
      defaultResponse.error = e
      return defaultResponse
    }
  }
}
